<script lang="ts" setup>
const handleRefresh = () => {
  location.reload()
}
</script>

<template>
  <div @click="handleRefresh" class="flex items-center">
    <el-icon :size="20"><Refresh /></el-icon>
    <span ml-4px>刷新</span>
  </div>
</template>
